module.exports = __webpack_public_path__ + "static/media/minus-cirlce.deb8587f.svg";